import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

const TransferConfirm = ({transferContact, transferAmount}) => {
  const {t} = useTranslation();

  const isMobile = window.innerWidth <= 768;
  const fontSize = "16px";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h4
        style={{
          margin: isMobile ? "0 0 2rem 0" : "2rem 0",
          fontWeight: 700,
          fontSize: isMobile ? fontSize : undefined,
        }}
      >
        {t("transferSteps_3_Confirm")}
      </h4>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: isMobile ? "100%" : 358,
          margin: isMobile ? undefined : "0 auto",
          paddingTop: isMobile ? "0" : "2.5rem",
          textAlign: "left",
        }}
      >
        <h4 style={{fontSize: isMobile ? fontSize : undefined, margin: 0}}>{t("transferSteps_3_Beneficiary")}:</h4>
        <h4
          style={{
            fontSize: isMobile ? fontSize : undefined,
            margin: 0,
            fontWeight: 400,
          }}
        >
          {transferContact?.name}
        </h4>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: isMobile ? "100%" : 358,
          margin: isMobile ? undefined : "0 auto",
          marginTop: isMobile ? "16px" : "0",
          textAlign: "left",
        }}
      >
        <h4 style={{fontSize: isMobile ? fontSize : undefined, margin: 0}}>{t("transferSteps_3_Amount")}:</h4>
        <h4
          style={{
            fontSize: isMobile ? fontSize : undefined,
            margin: 0,
            fontWeight: 400,
          }}
        >
          Bs. {transferAmount}
        </h4>
      </div>
    </div>
  );
};

TransferConfirm.propTypes = {
  transferContact: PropTypes.object.isRequired,
  transferAmount: PropTypes.number.isRequired,
};

export default TransferConfirm;
